import React from 'react';
import {Button, Col, FormControl, FormGroup, Panel, Row} from 'react-bootstrap';
import DateTime from 'react-datetime';

const ArticlesSearch = (props) => {
  const doSearch = (e) => {
    if (e.key === 'Enter') {
      props.onSearch();
    }
  };

  return (
    <Panel className="article-filter">
      <Row>
        <Col md={4}>
          <FormGroup>
            <FormControl
              onChange={props.onInputChange}
              onKeyPress={doSearch}
              placeholder="Article title keyword"
              value={props.searchValue}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <DateTime
              dateFormat="DD/MM/YYYY"
              inputProps={{
                placeholder: 'Display from'
              }}
              onChange={props.onDateFromChange}
              timeFormat="HH:mm"
              value={props.dateFromValue}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <DateTime
              dateFormat="DD/MM/YYYY"
              inputProps={{
                placeholder: 'Display to'
              }}
              onChange={props.onDateToChange}
              timeFormat="HH:mm"
              value={props.dateToValue}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <FormGroup>
            <FormControl
              componentClass="select"
              onChange={props.onStatusOrderChange}
              value={props.statusOrderValue}
            >
              <option value="">
                [Status]
              </option>
              {
                props.statusList.map(item => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))
              }
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <FormControl
              componentClass="select"
              onChange={props.onOrderByChange}
              value={props.orderByValue}
            >
              <option value="">
                [Sort by]
              </option>
              <option value="title">
                Title
              </option>
              <option value="display_to_date">
                Display to
              </option>
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={2}>
          <FormGroup>
            <FormControl
              componentClass="select"
              onChange={props.onOrderChange}
              value={props.orderValue}
              disabled={props.orderByValue === ''}
            >
              <option value="asc">
                Ascending
              </option>
              <option value="desc">
                Descending
              </option>
            </FormControl>
          </FormGroup>
        </Col>
        <Col className="actions" md={4}>
          <Button
            className="red-ghost-btn"
            onClick={props.onSearch}
          >
            Search
          </Button>

          <Button
            className="grey-ghost-btn"
            onClick={props.onClear}
          >
            Clear search/filters
          </Button>
        </Col>
      </Row>
    </Panel>
  );
};

export default ArticlesSearch;



// WEBPACK FOOTER //
// ./src/components/admin/news/articles/list/articles-search.jsx